<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="about-the-author">
<h1>About the Author</h1>
<p>As a boy, J.L. Riseden often found himself in trouble and grounded from the television, with that he would often be seen with his nose buried in a book. The scenes of what he read coming alive in his mind. He served six years in the United States Air Force, he is now a rural mailman in the small town of Power, Montana. As he drives down the back, country, roads delivering mail he listens to books. The thought of being an author alive once again in his mind. While stuck inside as the cold, winter, wind blew through Montana he had one thought, “I’ve already failed if I don’t try”, and with that he sat down at his computer and began to type with hopes that readers will enjoy their journey into the mind of J.L Riseden.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch001.vue?68387a5e